import styled from 'styled-components';
import { Input, Select } from 'antd';

export const StyledCpscCoreFormDiv = styled.div`
  .radio-group-horizontal .ant-radio-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }

  .radio-group-horizontal .ant-radio-wrapper {
    display: flex;
    align-items: center;
    margin-right: ${({ theme }) => theme.spacing.space_4};
    white-space: nowrap;
  }
`;

export const StyledRootFieldsDiv = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-top: ${({ theme }) => theme.spacing.space_5};
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
`;

export const StyledSelect = styled(Select)`
  display: block;
  margin-top: ${({ theme }) => theme.spacing.space_2};

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
  }
`;

export const StyledInput = styled(Input)`
  height: ${({ theme }) => theme.spacing.space_5};
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledAddonSelect = styled(Select)`
  width: ${({ theme }) => theme.size.micro_tiny};
  display: flex;
  flex-direction: row;

  .ant-select-selector {
    height: ${({ theme }) => theme.spacing.space_5} !important;
    padding-right: ${({ theme }) => theme.spacing.space_2} !important;
    padding-left: ${({ theme }) => theme.spacing.space_2} !important;
  }
`;
